// extracted by mini-css-extract-plugin
export var active = "Faq-module--active--8tc+q";
export var container = "Faq-module--container--SKjb2";
export var faqs = "Faq-module--faqs--90v1Z";
export var grid = "Faq-module--grid--kTATU";
export var mob = "Faq-module--mob--2QwYG";
export var post = "Faq-module--post--Z+lQb";